// extracted by mini-css-extract-plugin
module.exports = {"badge":"BadgeCount_badge__2D6Xe","badgeText":"BadgeCount_badgeText__3-Ae9","placeholderShimmer":"BadgeCount_placeholderShimmer__34Mut"};